import type { TNavTabs, ICheckoutCustomizationData } from "@app/dashboard/types/innerLayout/checkout_customization";
import { CHECKOUT_CUSTOMIZATION_EVENTS_VALUES } from "@app/dashboard/constants/tracking_events/checkout-customization";

export function filterToMatchStructure<T extends Record<string, any>>(
  template: ICheckoutCustomizationData,
  source: T
): ICheckoutCustomizationData {
  const result: Record<string, any> = {};

  for (const key in template) {
    if (key in source) {
      const templateValue = template[key as keyof ICheckoutCustomizationData];
      const sourceValue = source[key];

      if (typeof templateValue === 'object' && templateValue !== null && !Array.isArray(templateValue)) {
        result[key] = filterToMatchStructure(templateValue as any, sourceValue);
      } else {
        result[key] = sourceValue;
      }
    }
  }

  return result as ICheckoutCustomizationData;
};

export const NAVIGATION_TABS: Record<'BRANDING' | 'PAYMENT' | 'POST_PAYMENT', TNavTabs> = {
  BRANDING: "branding",
  PAYMENT: "payment",
  POST_PAYMENT: "post_payment",
};

const AMOUNT = 20000;
const ITEM_NAME = "Item name";
const ITEM_DESC = "Item description";
const ITEM_AMOUNT = 1;

const CHECKOUT_ITEM = {
  name: ITEM_NAME,
  amount: AMOUNT,
  description: ITEM_DESC,
  quantity: ITEM_AMOUNT
};

export const CHECKOUT_ORDER_DETAILS = {
  amount: AMOUNT,
  items: [CHECKOUT_ITEM]
};

export const BUSINESS_INFO_MAX_CHARS = 80;
export const PAYMENT_CONFIRMATION_MSG_MAX_CHARS = 100;
export const PAYMENT_CONFIRMATION_MSG_MIN_CHARS = 5;
export const PAYMENT_CONFIRMATION_MIN_SECS = 5;
export const PAYMENT_CONFIRMATION_MAX_SECS = 10;
export const PAYMENT_CONFIRMATION_DEFAULT_SECS = 5;
export const AUTO_REDIRECT = "AUTO_REDIRECT";
export const CUSTOMIZATION_SECTIONS_KEYS = {
  BUSINESS_LOGO: "merchant_logo",
  BUSINESS_INFO: "business_info",
  ACCENT_COLOR: "accent",
  ACTION_COLOR: "action",
  TERMS_URL: "termsUrl"
};


const MEGA_BYTE = 1024 * 1024;
export const MAX_LOGO_SIZE = 1 * MEGA_BYTE;
export const ALLOWED_FORMATS = [".jpeg", ".png", ".jpg"];

export const fontOptions = [
  { label: "Inter", value: "inter" },
  { label: "Roboto", value: "roboto" },
  { label: "Open Sans", value: "open-sans" },
  { label: "Lato", value: "lato" },
  { label: "Montserrat", value: "montserrat" },
  { label: "Oswald", value: "oswald" },
  { label: "Slabo", value: "slabo" },
  { label: "Raleway", value: "raleway" },
  { label: "PT Sans", value: "pt-sans" },
  { label: "Merriweather", value: "merriweather" },
  { label: "SF Pro", value: "sf-pro" }
];

export const styleOptions = [
  { label: "Rounded", value: "rounded" },
  { label: "Rectangular", value: "rectangular" },
];

export const INFO_MODAL_WIDTH = "30rem";

export const TAB_TO_EVENT_VALUE_MAP = {
  [NAVIGATION_TABS.BRANDING]: CHECKOUT_CUSTOMIZATION_EVENTS_VALUES.TABS.BRANDING,
  [NAVIGATION_TABS.PAYMENT]: CHECKOUT_CUSTOMIZATION_EVENTS_VALUES.TABS.PAYMENT,
  [NAVIGATION_TABS.POST_PAYMENT]: CHECKOUT_CUSTOMIZATION_EVENTS_VALUES.TABS.POST_PAYMENT
};